import { Environment } from './types/enums';

interface AppEnvironmentInterface {
  Environment: Environment;
  Api: ApiInterface;
}
interface ApiInterface {
  SURVEY_SOCKET_URL: string;
}

const getConfigurationOptions = (mode: string) => {
  switch (mode) {
    case Environment.Production: {
      return {
        Environment: Environment.Production,
        Api: {
          SURVEY_SOCKET_URL: 'wss://neo.pollpass.com'
        }
      };
    }
    case Environment.Staging: {
      return {
        Environment: Environment.Staging,
        Api: {
          SURVEY_SOCKET_URL: 'wss://neo-staging.pollpass.com'
        }
      };
    }
    default: {
      return {
        Environment: Environment.Testing,
        Api: {
          SURVEY_SOCKET_URL: 'wss://neo-testing.pollpass.com'
        }
      };
    }
  }
};

export const config: AppEnvironmentInterface = getConfigurationOptions(import.meta.env.VITE_ENVIRONMENT);
